import axios from "axios";
import Config from "../config";

const getRooms = (keyword = null) => {
    return axios({
        method: "post",
        url: (Config.url || '') + "/api/rooms/list",
        data: { limit: 30, keyword }
    });
};

export default getRooms;
